/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'edit': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M860 504c-19.9 0-36 16.1-36 36 0 1.4.1 2.7.2 4h-.2v344H136V200h376c19.9 0 36-16.1 36-36s-16.1-36-36-36H136c-39.8 0-72 32.2-72 72v688c0 39.8 32.2 72 72 72h688c39.8 0 72-32.2 72-72V544h-.2c.1-1.3.2-2.6.2-4 0-19.9-16.1-36-36-36z"/><path pid="1" d="M1002.7 100.3L923.4 21c-28.1-28.1-73.9-27.9-102 .2L424.2 418.4c-2.9 2.9-5.2 6.4-6.8 10.2L317.6 664c-5.6 13.2-1.7 26.5 6.8 35.1 8.5 8.6 21.9 12.5 35.2 6.9l235.5-99.7c3.8-1.6 7.2-3.9 10.2-6.8l397.2-397.2c28.1-28.1 28.3-73.9.2-102zM559.8 543l-137.4 58.2 58.2-137.4L759.4 185l79.2 79.2L559.8 543zm391.7-391.7l-62 62-79.2-79.2 62-62 .2-.2 79.2 79.2-.2.2z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/edit.js